<script>
    import TextEditor from "../../Common/TextEditor.svelte";
    import {getStyleValue, imageUrl} from '../../Common/tools';
    import {External} from "../../external";

    export let data, meta, globalStyle, onChange;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }
</script>
<tr>
    <th class="column mobile-12"
        style="padding-left: 100px; padding-right: 100px; font-weight: 400;" width="{getStyleValue(globalStyle.width, 600)}">
        <div align="center">
            <img src="{imageUrl(data, External.resources + '/images/marketing/placeholders/100x100.png')}" alt="Author Name"
                 style="border: 0; border-radius: 50%; width: 100%; width: 50px; height: 50px;" width="50">
        </div>
        <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
    </th>
</tr>
